import { useSelector } from 'react-redux';
import { getPurchaseItem } from '../../selectors';
import { IStore } from 'store/interface';
import { IStoreProduct } from '../../interfaces/reducer.leaders.interfaces';

export const usePurchaseModal = (data: boolean | (string | number)[]) => ({
  item: useSelector<IStore, IStoreProduct>(store => getPurchaseItem(store, data)),
});
